import {
	Typography,
	Grid,
	styled,
	TextField,
	InputAdornment,
} from '@mui/material';

import { useState } from 'react';

import { debounce } from 'lodash';

import { ReactComponent as FilterIcon } from 'common/assets/images/Filter.svg';
import { ReactComponent as Plus } from 'common/assets/images/Plus.svg';
import { ReactComponent as SearchOutlined } from 'common/assets/images/search-outline.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import { FeatureFlagsKeysEnum } from 'common/constants/FeatureFlags';
import {
	REPORTING_LIBRARY_MAIN_HEADING,
	REPORTING_LIBRARY_SUB_HEADING,
	REPORTING_ADD_REPORT_BUTTON_TEXT,
} from 'common/constants/ReportingLibraryConstants';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { useFeatureFlag } from 'hooks/useFeatureFlags';

import styles from './ReportingLibraryBanner.module.scss';

const {
	searchFieldBackground,
	searchFieldBorderRadius,
	checkboxCheckedcolor,
	addNewButtonColor,
} = styles;
const StyledSearchTextField = styled(TextField)({
	background: searchFieldBackground,
	borderRadius: searchFieldBorderRadius,
	width: '100%',
});

const ReportingLibraryBanner = () => {
	const isReportingLibrarySearchEnabled = useFeatureFlag(
		FeatureFlagsKeysEnum.IS_REPORTING_LIBRARY_SEARCH_ENABLED,
	);
	const isReportingLibraryFilterEnabled = useFeatureFlag(
		FeatureFlagsKeysEnum.IS_REPORTING_LIBRARY_FILTER_ENABLED,
	);
	const isReportingLibraryAddReportEnabled = useFeatureFlag(
		FeatureFlagsKeysEnum.IS_REPORTING_LIBRARY_ADD_REPORT_ENABLED,
	);
	const [reportingSearchText, setReportingSearchText] = useState<string>('');

	const changeSearchInput = (e: any) => {
		const text = e?.target.value;
		setReportingSearchText(text);
	};

	const debouncedSearchHandler = debounce((e) => {
		changeSearchInput(e);
	}, 500);

	return (
		<Grid
			container
			direction="column"
			className={styles['reporting-banner-grid']}
			data-testid="banner"
		>
			<Grid item>
				<Typography mb={1} className={styles['reporting-banner-main-text']}>
					{toSentenceCase(REPORTING_LIBRARY_MAIN_HEADING)}
				</Typography>
			</Grid>
			<Grid item>
				<Typography mb={1} className={styles['reporting-banner-sub-text']}>
					{toSentenceCase(REPORTING_LIBRARY_SUB_HEADING)}
				</Typography>
			</Grid>
			<Grid item>
				<Grid container direction="row">
					<Grid item xs={12} sm={9} md={9} lg={9} xl={9}>
						<div className={styles['reporting-search-grid']}>
							{isReportingLibrarySearchEnabled && (
								<StyledSearchTextField
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">
												<SearchOutlined
													className={styles['input-search-icon']}
												/>
											</InputAdornment>
										),
										inputProps: { 'data-testid': 'searchInput' },
									}}
									className={styles['reporting-search-input']}
									fullWidth={false}
									placeholder="Search"
									size="small"
									onChange={debouncedSearchHandler}
									defaultValue={reportingSearchText}
								/>
							)}
						</div>
					</Grid>
					<Grid item xs={12} sm={1} md={1} lg={1} xl={1}>
						<div className={styles['reporting-filter-button-grid']}>
							{isReportingLibraryFilterEnabled && (
								<ButtonComp
									btnType="secondary"
									variant="outlined"
									onClick={() => {}}
									data-testid="filter-icon"
								>
									<div className={styles['reporting-filter-icon']}>
										<FilterIcon fill={checkboxCheckedcolor} />
									</div>
								</ButtonComp>
							)}
						</div>
					</Grid>
					<Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
						<div className={styles['reporting-add-report-grid']}>
							{isReportingLibraryAddReportEnabled && (
								<ButtonComp
									btnType="secondary"
									variant="outlined"
									onClick={() => {}}
									data-testid="add-new-report"
								>
									<div className={styles['reporting-plus-icon']}>
										<Plus fill={addNewButtonColor} />
									</div>
									<Typography>
										{toSentenceCase(REPORTING_ADD_REPORT_BUTTON_TEXT)}
									</Typography>
								</ButtonComp>
							)}
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ReportingLibraryBanner;
